import VideoGridItem from "./VideoGridItem";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchVideos } from "../../features/videos/videosSlice";

import Loding from "../ui/Loding";
import NotFound from "../ui/NotFound";

export default function VideGrid() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const no = 0;
  const { tags, search, author } = state.filter;
  useEffect(() => {
    dispatch(fetchVideos({ tags, search, no }));
  }, [dispatch, tags, search]);

  const { videos, isLoding, isError, error } = state.videos;
  let content;

  if (!isError && isLoding) {
    content = <Loding />;
  }
  if (!isLoding && !isError && videos.length > 0) {
    content = videos
      .filter((data) => {
        if (author !== "") {
          return author.includes(data.author);
        }
        return true;
      })
      .map((video) => <VideoGridItem video={video} key={video.id} />);
  }
  if (isError && !isLoding) {
    content = <div className="col-span-12">{error}</div>;
  }
  if (!isLoding && !isError && videos.length === 0) {
    content = <NotFound />;
  }
  return (
    <section className="pt-12">
      <section className="pt-12">
        <div className="grid grid-cols-12 gap-4 max-w-7xl mx-auto px-5 lg:px-0 min-h-[300px]">
          {content}

          {/*  */}
        </div>
      </section>
    </section>
  );
}
